<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js + TypeScript App"/> -->
  <!-- <router-view /> -->
  <AppLayout /> 
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import AppLayout from './components/Layout/AppLayout.vue';

@Options({
  components: {
    AppLayout,
  },
})
export default class App extends Vue {}
</script>

<style>
@import url("@/assets/fonts/fonts.css");
#app {
  font-family: 'AlibabaPuHuiTi-Thin', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
